import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProfileImgDialogComponent } from 'app/shared/profile-img-dialog/profile-img-dialog.component';

@Component({
    selector     : 'classy-layout',
    templateUrl  : './classy.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ClassyLayoutComponent implements OnInit, OnDestroy
{
    isScreenSmall: boolean;
    navigation: Navigation;
    user: User;
    navigationMenuByUserRole: FuseNavigationItem[];
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        public dialog: MatDialog,
    )
    {
    }

    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    ngOnInit(): void
    {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
                this.updateNavigationMenu();
            });

        // Subscribe to the user service
        this._userService.user$
            .pipe((takeUntil(this._unsubscribeAll)))
            .subscribe((user: User) => {
                this.user = user;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    updateNavigationMenu()
    {
        let currentUserRole = localStorage.getItem('userRole');

        switch(currentUserRole)
        {
            case  "ROLE_Super Admin":
            {
                this.navigationMenuByUserRole = this.navigation.default;
                break;
            }
            case  "ROLE_Admin":
            {
                this.navigationMenuByUserRole = this.navigation.default;
                break;
            }
            case  "ROLE_Relationship Manager":
            {
                this.navigationMenuByUserRole = this.navigation.relationshipManager;
                break;
            }
            case  "ROLE_Underwriting":
            {
                this.navigationMenuByUserRole = this.navigation.underwriting;
                break;
            }
            case  "ROLE_Operations":
            {
                this.navigationMenuByUserRole = this.navigation.operations;
                break;
            }
            case "ROLE_Partner Admin":
                {
                    this.navigationMenuByUserRole = this.navigation.partnerAdmin;
                    break;
                }
                case "ROLE_Billing":
                {
                    this.navigationMenuByUserRole = this.navigation.billing;
                    break;
                }
        }
    }

    dialogRef: MatDialogRef<ProfileImgDialogComponent>;
    openProfileImgDialog() {
        this.dialogRef = this.dialog.open(ProfileImgDialogComponent,{
          width: '50%',
          data: ''
        });

        this.dialogRef.afterClosed().subscribe(res =>{
            if(res === true)
                this.getProfilePhoto();
          });
    }

    getProfilePhoto(){
        this._userService.apiGetUserPhoto(localStorage.getItem("userId")).subscribe((response)=>{
            if(response){
                let fileExtension = response.fileName.split('.').pop();
                if(fileExtension == "jpg"){
                    this.user.avatar = response.body.replace("application/octet-stream","image/jpg");
                }
                else if(fileExtension == "jpeg"){
                    this.user.avatar = response.body.replace("application/octet-stream","image/jpeg");
                }
                else if(fileExtension == "png"){
                    this.user.avatar = response.body.replace("application/octet-stream","image/png");
                }
            }
        },
    (error)=>{
        console.log(error);
    });
    }
}
